"use client";

import BG_HEADER from "@/assets/images/bg-header.jpg";
import { useMatchInfo } from "./MatchInfoContext";

export default function MatchHeader() {
  const { match, matchInfo, statsInfo } = useMatchInfo();

  const {
    formattedDate,
    formattedThu,
    formattedGio,
    isLive,
    isFinished,
  } = matchInfo;

  const {
    currentHomeScore,
    currentAwayScore,
    currentHomeHalfScore,
    currentAwayHalfScore,
    homeYellow,
    homeRed,
    awayYellow,
    awayRed,
    currentHomeCorner,
    currentAwayCorner,
  } = statsInfo;

  const hasCards = [homeYellow, homeRed, awayYellow, awayRed].some((v) => v != null && v !== "");
  const hasCorners = currentHomeCorner != null && currentAwayCorner != null;

  return (
    <div
      className="overflow-hidden bg-cover bg-center bg-no-repeat -mx-4 px-4 py-4"
      style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url(${BG_HEADER})` }}
    >
      <div className="text-center">
        <p className="text-sm text-[var(--theme-foreground)]">{match.leagueName}</p>
        <p className="text-sm text-[var(--theme-foreground)] mt-1">{`${formattedThu} ${formattedDate} - ${formattedGio}`}</p>
      </div>

      <div className="flex items-center justify-between gap-4 sm:gap-6 py-4 sm:py-6">
        <div className="flex-1 flex flex-col items-center gap-2 sm:gap-3 text-center min-w-0">
          {match.homeTeam?.logo && (
            <img src={match.homeTeam.logo} alt="" className="w-14 h-14 sm:w-20 sm:h-20 object-contain shrink-0" />
          )}
          <p className="font-semibold text-[var(--theme-foreground)] text-base sm:text-lg truncate w-full">{match.homeName}</p>
        </div>
        <div className="text-center shrink-0">
          {(isLive || isFinished) ? (
            <div className="text-2xl sm:text-3xl font-bold text-[var(--theme-foreground)]">
              {currentHomeScore} - {currentAwayScore}
            </div>
          ) : (
            <div className="text-xl sm:text-2xl font-medium text-[var(--theme-foreground)]">VS</div>
          )}
          {(isLive || isFinished) && (
            <p className="text-xs text-[var(--theme-foreground)] mt-1">
              HT: {currentHomeHalfScore} - {currentAwayHalfScore}
            </p>
          )}
        </div>
        <div className="flex-1 flex flex-col items-center gap-2 sm:gap-3 text-center min-w-0">
          {match.awayTeam?.logo && (
            <img src={match.awayTeam.logo} alt="" className="w-14 h-14 sm:w-20 sm:h-20 object-contain shrink-0" />
          )}
          <p className="font-semibold text-[var(--theme-foreground)] text-base sm:text-lg truncate w-full">{match.awayName}</p>
        </div>
      </div>
      {(hasCards || hasCorners) && (
        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs text-[var(--theme-foreground)] pt-2 border-t border-[var(--theme-foreground)]/20">
          {hasCards && (
            <span className="flex items-center gap-1">
              <span className="text-yellow-400" title="Thẻ vàng">🟨</span>
              {homeYellow ?? 0}-{awayYellow ?? 0}
              <span className="text-red-500 ml-1" title="Thẻ đỏ">🟥</span>
              {homeRed ?? 0}-{awayRed ?? 0}
            </span>
          )}
          {hasCorners && (
            <span>Góc: {currentHomeCorner}-{currentAwayCorner}</span>
          )}
        </div>
      )}
    </div>
  );
}
